"use strict";
// Fork of https://github.com/sindresorhus/decamelize because it contains ES6 code
// And css properties don't contain unicode
Object.defineProperty(exports, "__esModule", { value: true });
const separator = '-';
const regex1 = /([a-z\d])([A-Z])/g;
const regex2 = /([a-z]+)([A-Z][a-z\d]+)/g;
function decamelize(text) {
    return text
        .replace(regex1, `$1${separator}$2`)
        .replace(regex2, `$1${separator}$2`)
        .toLowerCase();
}
exports.default = decamelize;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVjYW1lbGl6ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9kZWNhbWVsaXplLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxrRkFBa0Y7QUFDbEYsMkNBQTJDOztBQUUzQyxNQUFNLFNBQVMsR0FBRyxHQUFHLENBQUE7QUFDckIsTUFBTSxNQUFNLEdBQUcsbUJBQW1CLENBQUE7QUFDbEMsTUFBTSxNQUFNLEdBQUcsMEJBQTBCLENBQUE7QUFFekMsU0FBd0IsVUFBVSxDQUFDLElBQVk7SUFDN0MsT0FBTyxJQUFJO1NBQ1IsT0FBTyxDQUFDLE1BQU0sRUFBRSxLQUFLLFNBQVMsSUFBSSxDQUFDO1NBQ25DLE9BQU8sQ0FBQyxNQUFNLEVBQUUsS0FBSyxTQUFTLElBQUksQ0FBQztTQUNuQyxXQUFXLEVBQUUsQ0FBQTtBQUNsQixDQUFDO0FBTEQsNkJBS0MifQ==